(function () {
  var _fetch = window.fetch;
  window.fetch = function (resource, init) {
    try {
      var url = String(resource);
      if (url.indexOf('search/suggest') !== -1) {
        var parsed = new URL(url, window.location.origin);
        var key = 'resources[options][fields]';
        var fields = parsed.searchParams.get(key);
        if (fields) {
          if (fields.split(',').indexOf('tag') === -1) {
            parsed.searchParams.set(key, fields + ',tag');
          }
        } else {
          parsed.searchParams.set(key, 'title,product_type,variants.title,vendor,tag');
        }
        resource = parsed.pathname + parsed.search;
      }
    } catch (e) { }
    return _fetch.apply(this, [resource, init]);
  };
})();

function syncQuickAddToSwatch(productCard, swatch) {
  if (!productCard || !swatch || !swatch.dataset.handle || !swatch.dataset.variantId) return;
  const qa = productCard.querySelector('product-quick-add');
  if (!qa) return;
  qa.setAttribute('data-handle', swatch.dataset.handle);
  qa.setAttribute('data-id', swatch.dataset.variantId);
  if (typeof qa.syncVariantFromDom === 'function') qa.syncVariantFromDom();
}

function applySwatchToCard(productCard, swatch, syncQuickAdd) {
  if (!productCard || !swatch) return;
  if (syncQuickAdd === undefined) syncQuickAdd = true;
  const img = productCard.querySelector(`.image-${swatch.dataset.handle}`);
  productCard.querySelectorAll('.product-card--image-wrapper img.active').forEach(function (i) { i.classList.remove('active'); });
  if (img) img.classList.add('active');
  const titleEl = productCard.querySelector('.product-card--title');
  if (titleEl && swatch.dataset.productTitle !== undefined) {
    titleEl.textContent = swatch.dataset.productTitle;
  }
  const priceEl = productCard.querySelector('.product--price');
  const compareEl = productCard.querySelector('.product--compare-price');
  if (priceEl && swatch.dataset.price !== undefined) {
    priceEl.textContent = swatch.dataset.price;
  }
  if (compareEl) {
    if (swatch.dataset.comparePrice) {
      compareEl.textContent = swatch.dataset.comparePrice;
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }
  const promotionPrice = productCard.querySelector('catalog-promotion-price');
  if (promotionPrice && typeof promotionPrice.setPrice === 'function') {
    promotionPrice.setPrice(Number(swatch.dataset.priceCents), swatch.dataset.promotionEligible === 'true');
  }
  const url = swatch.dataset.url;
  if (url) {
    productCard.querySelectorAll('a.product-card--image-wrapper, a.product-card--title-link').forEach(function (a) {
      a.setAttribute('href', url);
    });
  }
  if (syncQuickAdd) syncQuickAddToSwatch(productCard, swatch);
}

function revertCardToDefaults(productCard) {
  if (!productCard) return;
  const activeSwatch = productCard.querySelector('.product-card--details .swatches--container a.swatch.active');
  if (activeSwatch) {
    applySwatchToCard(productCard, activeSwatch, false);
  } else {
    const activeImg = productCard.querySelector('img.active');
    if (activeImg) activeImg.classList.remove('active');
    const titleEl = productCard.querySelector('.product-card--title');
    if (titleEl && productCard.dataset.defaultTitle !== undefined) {
      titleEl.textContent = productCard.dataset.defaultTitle;
    }
    const priceEl = productCard.querySelector('.product--price');
    const compareEl = productCard.querySelector('.product--compare-price');
    if (priceEl && productCard.dataset.defaultPrice !== undefined) {
      priceEl.textContent = productCard.dataset.defaultPrice;
    }
    if (compareEl && productCard.dataset.defaultComparePrice !== undefined) {
      if (productCard.dataset.defaultComparePrice) {
        compareEl.textContent = productCard.dataset.defaultComparePrice;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    const promotionPrice = productCard.querySelector('catalog-promotion-price');
    if (promotionPrice && typeof promotionPrice.setPrice === 'function') {
      promotionPrice.setPrice(Number(productCard.dataset.defaultPriceCents), productCard.dataset.defaultPromotionEligible === 'true');
    }
    const defaultUrl = productCard.dataset.defaultUrl;
    if (defaultUrl) {
      productCard.querySelectorAll('a.product-card--image-wrapper, a.product-card--title-link').forEach(function (a) {
        a.setAttribute('href', defaultUrl);
      });
    }
  }
}

document.addEventListener('mouseenter', function (e) {
  if (!e.target || typeof e.target.closest !== 'function') return;
  const target = e.target.closest('.product-card--details .swatches--container a:not(.swatch.active)');
  if (target) {
    applySwatchToCard(target.closest('.product-card--root'), target, false);
  }
}, true);

document.addEventListener('mouseleave', function (e) {
  if (!e.target || typeof e.target.closest !== 'function') return;
  const target = e.target.closest('.product-card--details .swatches--container a:not(.swatch.active)');
  if (target) {
    revertCardToDefaults(target.closest('.product-card--root'));
  }
}, true);

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.product-card--details .swatches--container a.swatch');
  if (!swatch) return;
  const productCard = swatch.closest('.product-card--root');
  if (!productCard) return;
  e.preventDefault();
  e.stopPropagation();
  swatch.closest('.swatches--container').querySelectorAll('a.swatch').forEach(function (s) { s.classList.remove('active'); });
  swatch.classList.add('active');
  applySwatchToCard(productCard, swatch);
  productCard.dataset.defaultTitle = swatch.dataset.productTitle || '';
  productCard.dataset.defaultPrice = swatch.dataset.price || '';
  productCard.dataset.defaultComparePrice = swatch.dataset.comparePrice || '';
  if (swatch.dataset.url) productCard.dataset.defaultUrl = swatch.dataset.url;
}, true);

document.addEventListener(
  'click',
  function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var a = e.target.closest('.product-quick-add--form .meta-swatches .swatches--container a.swatch[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
    var formRoot = a.closest('.product-quick-add--form');
    if (!formRoot) return;
    var handle = a.dataset.handle;
    var variantId = a.dataset.variantId;
    if (!handle || !variantId) return;
    e.preventDefault();
    e.stopPropagation();
    var qa = null;
    document.querySelectorAll('product-quick-add').forEach(function (el) {
      if (el.form === formRoot) qa = el;
    });
    if (!qa) return;
    qa.setAttribute('data-handle', handle);
    qa.setAttribute('data-id', variantId);
    if (typeof qa.syncVariantFromDom === 'function') qa.syncVariantFromDom();
    qa.fetchForm().then(function () {
      if (window.trigger) window.trigger('theme:quickAdd:toggle', qa.getAttribute('data-handle'));
      if (window.Shopify && window.Shopify.PaymentButton) {
        try {
          window.Shopify.PaymentButton.init();
        } catch (err) {}
      }
    });
  },
  true
);

customElements.whenDefined('product-quick-add').then(function () {
  var QA = customElements.get('product-quick-add');
  if (!QA || !QA.prototype || QA.prototype.__cascadiaQuickAddPatched) return;
  QA.prototype.__cascadiaQuickAddPatched = true;

  QA.prototype.syncVariantFromDom = function () {
    var id = this.getAttribute('data-id');
    var h = this.getAttribute('data-handle');
    var prevHandle = this.handle;
    if (h && prevHandle && h !== prevHandle && this.form) {
      try {
        if (this.form.parentNode) this.form.parentNode.removeChild(this.form);
      } catch (e) {}
      this.form = null;
    }
    if (id) {
      this.variant_id = String(id);
      this.query = '?section_id=product-quick-add--form&variant=' + this.variant_id;
    }
    if (h) {
      this.handle = h;
      this.form_selector = '.product-quick-add--form[data-handle="' + h + '"]';
    }
  };

  var _fetchForm = QA.prototype.fetchForm;
  QA.prototype.fetchForm = async function () {
    if (typeof this.syncVariantFromDom === 'function') this.syncVariantFromDom();
    return _fetchForm.apply(this, arguments);
  };

  var _addToCart = QA.prototype.addToCart;
  QA.prototype.addToCart = async function () {
    if (typeof this.syncVariantFromDom === 'function') this.syncVariantFromDom();
    return _addToCart.apply(this, arguments);
  };
});

customElements.whenDefined('main-product-carousel').then(function () {
  var ProductCarousel = customElements.get('main-product-carousel');
  if (!ProductCarousel) return;

  var _load = ProductCarousel.prototype.load;
  ProductCarousel.prototype.load = function () {
    _load.call(this);
    this._pcDots = Array.from(this.querySelectorAll('.product-carousel-dot'));
    if (this._pcDots.length) {
      this._syncDots();
      var self = this;
      this._pcDots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          self.updateThenGoToActiveSlide(i + 1);
        });
      });
    }
  };

  var _updateActive = ProductCarousel.prototype.updateActive;
  ProductCarousel.prototype.updateActive = function () {
    _updateActive.call(this);
    this._syncDots && this._syncDots();
  };

  ProductCarousel.prototype._syncDots = function () {
    var activeSlide = this.active_slide;
    this._pcDots && this._pcDots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', (i + 1 === activeSlide) ? 'true' : 'false');
    });
  };
});

// Collection filter accordions: handle in capture so Maker theme Navigation#menuToggleListeners does not
// run (it left data-transition-active false). Toggle aria + menu state locally.
function filterSidebarToggleInteract(e) {
  if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
  var root = e.target && e.target.closest ? e.target.closest('.filter--root') : null;
  var toggle = e.target && e.target.closest ? e.target.closest('.filter--toggle') : null;
  var menu = toggle ? toggle.nextElementSibling : null;
  var menuOk = !!(menu && menu.classList && menu.classList.contains('filter--menu'));
  if (!toggle || !root) return;
  if (!menuOk) return;
  if (e.type === 'keydown') e.preventDefault();
  e.stopPropagation();
  var expanded = toggle.getAttribute('aria-expanded') === 'true';
  var open = !expanded;
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  menu.setAttribute('data-transition-active', open ? 'true' : 'false');
}
document.addEventListener('click', filterSidebarToggleInteract, true);
document.addEventListener('keydown', filterSidebarToggleInteract, true);

// Product form & quick-add drawer: Maker theme updates variant id asynchronously after option change
// (section fetch). If add to cart runs while product-options-element is still aria-busy, or if the
// hidden id lags behind variant-json, the wrong variant is submitted. Sync from variant-json on submit.
(function () {
  function applyVariantToInput(input, v) {
    if (!v || !v.id) return;
    input.value = String(v.id);
    input.setAttribute('data-id', String(v.id));
    if (v.sku !== undefined) input.setAttribute('data-sku', v.sku || '');
    if (v.inventory_management !== undefined) input.setAttribute('data-management', v.inventory_management || '');
    if (v.inventory_policy !== undefined) input.setAttribute('data-policy', v.inventory_policy || '');
    if (v.inventory_quantity !== undefined) input.setAttribute('data-quantity', String(v.inventory_quantity));
  }

  // Theme sets return_to once at load; it keeps the initial ?variant=. After a size change, sync so
  // cart redirect and reload land on the variant that was actually added.
  function syncUrlAndReturnTo(form, variantId) {
    if (!variantId) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', String(variantId));
      var buyRoot = form.querySelector('product-buy-buttons-element');
      if (buyRoot && buyRoot.dataset.cartType === 'drawer') {
        u.searchParams.set('open_cart_drawer', '1');
      }
      var pathSearchHash = u.pathname + u.search + (u.hash || '');
      var returnToInput = form.querySelector('input[name="return_to"]');
      if (returnToInput) {
        returnToInput.value = pathSearchHash;
      }
      history.replaceState({}, '', pathSearchHash);
    } catch (err) {}
  }

  function waitBusy(opts, timeoutMs) {
    return new Promise(function (resolve) {
      if (opts.getAttribute('aria-busy') !== 'true') {
        resolve();
        return;
      }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        clearTimeout(tid);
        obs.disconnect();
        resolve();
      }
      var obs = new MutationObserver(function () {
        if (opts.getAttribute('aria-busy') !== 'true') finish();
      });
      obs.observe(opts, { attributes: true, attributeFilter: ['aria-busy'] });
      var tid = setTimeout(finish, timeoutMs || 15000);
    });
  }

  function isProductVariantForm(form) {
    return (
      form &&
      form.tagName === 'FORM' &&
      (form.classList.contains('product-form') || form.classList.contains('product-quick-add--form'))
    );
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!isProductVariantForm(form)) return;
      var opts = form.querySelector('product-options-element');
      if (!opts) return;
      var input = form.querySelector('input[name="id"].product-buy-buttons--input');
      var vEl = opts.querySelector('[id^="variant-json"]');
      if (!input || !vEl) return;

      var isQuickAdd = form.classList.contains('product-quick-add--form');

      function syncFromJson() {
        try {
          var v = JSON.parse(vEl.textContent);
          applyVariantToInput(input, v);
          return v;
        } catch (err) {
          return null;
        }
      }

      function maybeSyncUrl() {
        if (!isQuickAdd) {
          syncUrlAndReturnTo(form, input.value);
        }
      }

      if (opts.getAttribute('aria-busy') === 'true') {
        e.preventDefault();
        e.stopPropagation();
        var sub = e.submitter;
        waitBusy(opts, 15000).then(function () {
          syncFromJson();
          maybeSyncUrl();
          if (sub) form.requestSubmit(sub);
          else form.requestSubmit();
        });
        return;
      }

      syncFromJson();
      maybeSyncUrl();
    },
    true
  );
})();

(function () {
  function wrapReviewCountText(text) {
    if (!text || !/\d[\d,]*\s+Reviews?/i.test(text)) return text;
    if (/\(\s*\d[\d,]*\s+Reviews?\s*\)/i.test(text)) return text;
    return text.replace(/(\d[\d,]*)\s+(Reviews?)/gi, '($1 $2)');
  }

  function formatReviewLabel(el) {
    if (!el || el.dataset.yotpoReviewFormatted === 'true') return;
    var text = (el.textContent || '').trim();
    if (!text) return;
    var formatted = wrapReviewCountText(text);
    if (formatted !== text) {
      el.textContent = formatted;
      el.dataset.yotpoReviewFormatted = 'true';
    }
  }

  function formatYotpoBottomLine(root) {
    if (!root) return;
    root.querySelectorAll('.yotpo .text-m, .yotpo a.text-m').forEach(formatReviewLabel);
    root.querySelectorAll('.yotpo .standalone-bottomline').forEach(function (line) {
      line.childNodes.forEach(function (node) {
        if (node.nodeType !== 3) return;
        var text = node.textContent || '';
        var formatted = wrapReviewCountText(text);
        if (formatted !== text) node.textContent = formatted;
      });
    });
  }

  function initYotpoBottomLineFormatting() {
    var roots = document.querySelectorAll('.main-product--root');
    roots.forEach(function (root) {
      formatYotpoBottomLine(root);
      if (root.dataset.yotpoFormatObserved === 'true') return;
      root.dataset.yotpoFormatObserved = 'true';
      new MutationObserver(function () {
        formatYotpoBottomLine(root);
      }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYotpoBottomLineFormatting);
  } else {
    initYotpoBottomLineFormatting();
  }

  document.addEventListener('shopify:section:load', initYotpoBottomLineFormatting);
  window.setTimeout(initYotpoBottomLineFormatting, 1500);
})();

// Hide Yotpo reviewer "Age:" custom fields. Reviews load asynchronously, so we
// re-run on DOM mutations rather than once on page load.
(function () {
  function hideYotpoAgeFields(root) {
    (root || document).querySelectorAll('.yotpo-user-field').forEach(function (field) {
      var label = field.querySelector('.yotpo-user-field-description');
      if (label && label.textContent.trim() === 'Age:') {
        field.style.display = 'none';
      }
    });
  }

  function initYotpoAgeFieldHiding() {
    hideYotpoAgeFields(document);
    if (document.body.dataset.yotpoAgeHidden === 'true') return;
    document.body.dataset.yotpoAgeHidden = 'true';
    new MutationObserver(function () {
      hideYotpoAgeFields(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYotpoAgeFieldHiding);
  } else {
    initYotpoAgeFieldHiding();
  }

  document.addEventListener('shopify:section:load', initYotpoAgeFieldHiding);
})();

// Yotpo legacy widget DOM cleanup
// The legacy reviews widget injects its promoted-products module even when the
// standalone widget is not enabled. Remove that module instead of only hiding
// it so its heading and links are not present in the document structure. Yotpo
// also injects the review and question form titles as H2 elements; preserve
// their appearance and position while changing those two titles to divs.
(function () {
  function removeYotpoPromotedProducts(root) {
    if (!root) return;

    if (
      root.nodeType === 1 &&
      typeof root.matches === 'function' &&
      root.matches('.promoted-products-box')
    ) {
      root.remove();
      return;
    }

    if (typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('.promoted-products-box').forEach(function (section) {
      section.remove();
    });
  }

  function replaceYotpoFormTitles(root) {
    if (!root) return;

    var titles = [];
    if (
      root.nodeType === 1 &&
      typeof root.matches === 'function' &&
      root.matches('h2.y-label.yotpo-header-title')
    ) {
      titles.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll('h2.y-label.yotpo-header-title').forEach(function (title) {
        titles.push(title);
      });
    }

    titles.forEach(function (title) {
      var text = (title.textContent || '').trim().toLowerCase();
      if (text !== 'write a review' && text !== 'ask a question') return;

      var replacement = document.createElement('div');
      Array.prototype.forEach.call(title.attributes, function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      replacement.innerHTML = title.innerHTML;
      title.replaceWith(replacement);
    });
  }

  function initYotpoLegacyWidgetCleanup() {
    removeYotpoPromotedProducts(document);
    replaceYotpoFormTitles(document);
    if (!document.body || document.body.dataset.yotpoLegacyWidgetObserved === 'true') return;

    document.body.dataset.yotpoLegacyWidgetObserved = 'true';
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          removeYotpoPromotedProducts(node);
          replaceYotpoFormTitles(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYotpoLegacyWidgetCleanup);
  } else {
    initYotpoLegacyWidgetCleanup();
  }

  document.addEventListener('shopify:section:load', initYotpoLegacyWidgetCleanup);
})();
// End Yotpo legacy widget DOM cleanup

(function () {
  var KL_BIS_SELECTORS =
    '[class*="klaviyo-bis"], [id*="klaviyo-bis"], .klaviyo-bis-trigger, #klaviyo-bis-button';

  var klaviyoFormsReady = false;
  var autoTestPending = false;

  function tryAutoTriggerEarlyAccessTest() {
    if (!autoTestPending) return;

    var root = document.querySelector('product-buy-buttons-element[data-limited-edition="true"]');
    if (!root) return;

    var block = root.querySelector('[data-early-access-block]');
    if (!block || block.hasAttribute('hidden') || !klaviyoFormsReady) return;

    autoTestPending = false;
    dispatchOpenForm(root.dataset.earlyAccessForm || 'RE2cmp');

    var params = new URLSearchParams(window.location.search);
    params.delete('early_access_test');
    var cleanSearch = params.toString();
    history.replaceState(
      {},
      '',
      window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash
    );
  }

  function markKlaviyoFormsReady() {
    if (klaviyoFormsReady) return;
    klaviyoFormsReady = true;
    tryAutoTriggerEarlyAccessTest();
  }

  function dispatchOpenForm(formId) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  var _xhrOpen = XMLHttpRequest.prototype.open;
  var _xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__klaviyoUrl = url;
    return _xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var url = String(this.__klaviyoUrl || '');
    if (url.indexOf('full-forms') !== -1) {
      this.addEventListener('load', function () {
        if (this.status === 200) markKlaviyoFormsReady();
      });
    }
    return _xhrSend.apply(this, arguments);
  };

  function isLocalThemeDev() {
    var host = window.location.hostname;
    return (
      window.location.protocol === 'http:' &&
      (host === '127.0.0.1' || host === 'localhost') &&
      window.location.port === '9292'
    );
  }

  function resolvePreviewUrl(root) {
    var previewUrl = root && root.dataset.shopifyPreviewUrl;
    if (!previewUrl) return null;

    var input = root.querySelector('.product-buy-buttons--input');
    if (!input || !input.value) return previewUrl;

    try {
      var url = new URL(previewUrl);
      url.searchParams.set('variant', input.value);
      return url.toString();
    } catch (err) {
      return previewUrl;
    }
  }

  function getTranslations(root) {
    var script = root.querySelector('script[type="application/json"]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (err) {
      return {};
    }
  }

  function getSelectedVariant(root) {
    var form = root.closest('form');
    if (!form) return null;
    var opts = form.querySelector('product-options-element');
    if (!opts) return null;
    var vEl = opts.querySelector('[id^="variant-json"]');
    if (!vEl) return null;
    try {
      return JSON.parse(vEl.textContent);
    } catch (err) {
      return null;
    }
  }

  function isVariantSoldOut(root) {
    var variant = getSelectedVariant(root);
    if (variant && variant.id) {
      return variant.available === false;
    }

    if (root.dataset.earlyAccessActive === 'true') {
      return true;
    }

    var btn = root.querySelector('.product-buy-buttons--primary');
    if (btn && btn.hasAttribute('disabled')) {
      return true;
    }

    var translations = getTranslations(root);
    var textEl = root.querySelector('.product-buy-buttons--cta-text');
    if (
      textEl &&
      translations.out_of_stock &&
      textEl.textContent.trim() === translations.out_of_stock.trim()
    ) {
      return true;
    }

    return false;
  }

  function hideKlaviyoBIS() {
    if (!document.querySelector('form.product-form--early-access')) return;
    document.querySelectorAll(KL_BIS_SELECTORS).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('data-hidden-by-early-access', 'true');
    });
  }

  function showKlaviyoBIS() {
    document.querySelectorAll('[data-hidden-by-early-access="true"]').forEach(function (el) {
      el.style.removeProperty('display');
      el.removeAttribute('data-hidden-by-early-access');
    });
  }

  function openKlaviyoForm(formId, root) {
    var previewUrl = resolvePreviewUrl(root);

    if (isLocalThemeDev() && previewUrl) {
      var previewWindow = window.open(previewUrl, '_blank', 'noopener,noreferrer');
      if (previewWindow == null) {
        window.location.assign(previewUrl);
      }
      return;
    }

    dispatchOpenForm(formId);
  }

  function maybeAutoTriggerEarlyAccessTest() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('early_access_test') !== '1') return;

    autoTestPending = true;
    tryAutoTriggerEarlyAccessTest();

    var root = document.querySelector('product-buy-buttons-element[data-limited-edition="true"]');
    if (!root) return;

    var obs = new MutationObserver(function () {
      tryAutoTriggerEarlyAccessTest();
    });
    obs.observe(root, { subtree: true, attributes: true, childList: true });
  }

  function getEarlyAccessHeading(root) {
    var translations = getTranslations(root);
    return translations.early_access_heading || '';
  }

  function earlyAccessLabelNeedsRestore(root) {
    var heading = getEarlyAccessHeading(root);
    if (!heading) return false;
    var eaBtn = root.querySelector('.product-buy-buttons--early-access-btn');
    if (!eaBtn) return false;
    var eaText = eaBtn.querySelector('.product-buy-buttons--cta-text');
    return (
      eaBtn.getAttribute('data-text') !== heading ||
      !eaText ||
      eaText.textContent.trim() !== heading.trim()
    );
  }

  function restoreEarlyAccessLabel(root) {
    // Theme ProductBuyButtons.updateView() rewrites ALL .product-buy-buttons--cta-text
    // nodes (including the early-access CTA) to "Out of stock" on sold-out variants.
    // Only write when needed to avoid MutationObserver feedback loops.
    if (!earlyAccessLabelNeedsRestore(root)) return false;
    var heading = getEarlyAccessHeading(root);
    var eaBtn = root.querySelector('.product-buy-buttons--early-access-btn');
    if (!eaBtn) return false;
    eaBtn.setAttribute('data-text', heading);
    var eaText = eaBtn.querySelector('.product-buy-buttons--cta-text');
    if (eaText) eaText.textContent = heading;
    return true;
  }

  function applyEarlyAccess(root, enable) {
    var form = root.closest('form');
    var block = root.querySelector('[data-early-access-block]');

    root.__earlyAccessSyncing = true;
    if (root.__earlyAccessSyncTimer) clearTimeout(root.__earlyAccessSyncTimer);

    if (enable) {
      if (form) form.classList.add('product-form--early-access');
      if (block) block.removeAttribute('hidden');
      restoreEarlyAccessLabel(root);
      hideKlaviyoBIS();
    } else {
      if (form) form.classList.remove('product-form--early-access');
      if (block) block.setAttribute('hidden', '');
      showKlaviyoBIS();
    }

    // Keep syncing flag through MutationObserver microtask delivery to prevent loops.
    root.__earlyAccessSyncTimer = setTimeout(function () {
      root.__earlyAccessSyncing = false;
      root.__earlyAccessSyncTimer = null;
    }, 0);
  }

  function syncEarlyAccessState(root) {
    if (root.dataset.limitedEdition !== 'true' || root.__earlyAccessSyncing) return;

    var shouldBeEarlyAccess = isVariantSoldOut(root);
    var wasEarlyAccess = root.dataset.earlyAccessActive === 'true';
    var block = root.querySelector('[data-early-access-block]');
    var blockHidden = !!(block && block.hasAttribute('hidden'));
    var labelWrong = earlyAccessLabelNeedsRestore(root);

    if (shouldBeEarlyAccess) {
      root.dataset.earlyAccessActive = 'true';
      if (!wasEarlyAccess || blockHidden || labelWrong) {
        applyEarlyAccess(root, true);
      }
    } else if (wasEarlyAccess) {
      root.dataset.earlyAccessActive = 'false';
      applyEarlyAccess(root, false);
    }
  }

  function bindVariantListener(root) {
    var productId = root.dataset.id;
    if (!productId || root.__earlyAccessVariantBound) return;
    root.__earlyAccessVariantBound = true;

    var handler = function () {
      requestAnimationFrame(function () {
        syncEarlyAccessState(root);
      });
    };

    if (typeof window.on === 'function') {
      window.on('theme:product:' + productId + ':variantChanged.EarlyAccess', handler);
    } else {
      window.addEventListener('theme:product:' + productId + ':variantChanged', handler);
    }
  }

  function initEarlyAccessController(root) {
    if (root.__earlyAccessInit || root.dataset.limitedEdition !== 'true') return;
    root.__earlyAccessInit = true;

    if (root.querySelector('[data-early-access-block]:not([hidden])')) {
      root.dataset.earlyAccessActive = 'true';
      var form = root.closest('form');
      if (form) form.classList.add('product-form--early-access');
      hideKlaviyoBIS();
    }

    syncEarlyAccessState(root);
    bindVariantListener(root);

    var observer = new MutationObserver(function () {
      if (root.__earlyAccessSyncing) return;
      syncEarlyAccessState(root);
    });

    observer.observe(root, {
      attributes: true,
      attributeFilter: ['disabled', 'data-text', 'hidden'],
      subtree: true,
      childList: true,
      characterData: true,
    });
  }

  function scanForEarlyAccessRoots() {
    document
      .querySelectorAll('product-buy-buttons-element[data-limited-edition="true"]')
      .forEach(initEarlyAccessController);
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('.product-buy-buttons--early-access-btn[data-early-access="true"]');
      if (!btn) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var root = btn.closest('product-buy-buttons-element');
      var formId = (root && root.dataset.earlyAccessForm) || 'RE2cmp';
      openKlaviyoForm(formId, root);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanForEarlyAccessRoots();
      maybeAutoTriggerEarlyAccessTest();
    });
  } else {
    scanForEarlyAccessRoots();
    maybeAutoTriggerEarlyAccessTest();
  }

  new MutationObserver(function () {
    scanForEarlyAccessRoots();
    hideKlaviyoBIS();
  }).observe(document.body, { childList: true, subtree: true });

  customElements.whenDefined('product-quick-add').then(function () {
    var QA = customElements.get('product-quick-add');
    if (!QA || !QA.prototype || QA.prototype.__earlyAccessPatched) return;
    QA.prototype.__earlyAccessPatched = true;

    var fetchForm = QA.prototype.fetchForm;
    QA.prototype.fetchForm = async function () {
      var result = await fetchForm.apply(this, arguments);
      scanForEarlyAccessRoots();
      return result;
    };
  });
})();
